import { Button, Checkbox } from "antd";
import {Controller, useFormContext} from "react-hook-form";
import { DeleteOutlined } from "@ant-design/icons";

const CheckBoxHorizontal = ({label, top = false, htmlFor, values, required}) => {
  const {register, watch, setValue, control} = useFormContext();

  if (!register) {
    throw new Error("No form content and no register passed");
  }
  
  const value = watch(htmlFor)

  const checked = !!value && value.length > 0
  const handleChange = () => {
    if (checked) {
      setValue(htmlFor, [], {shouldDirty: true})
    }
  }

  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center ${top ? "" : "sm:border-t"
      } sm:border-gray-200 py-5`}
    >
      <label
        htmlFor={label}
        className="flex items-center text-sm font-medium text-gray-700"
      >
        <Button type="link" icon={<DeleteOutlined />} onClick={handleChange} danger disabled={!checked} />
        {label}
      </label>
        <Controller
          name={htmlFor}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Checkbox.Group options={values.map(({_id, name}) => ({label: name, value: _id}))}  value={value} onChange={onChange}/>
          )}
        />
    </div>
  );
};
export default CheckBoxHorizontal;
